export default "__VITE_ASSET__718d85c1__"